
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","d":"M3.5 9.352a.996.996 0 0 1 1-.993h8c.552 0 1 .445 1 .993v5.15a.996.996 0 0 1-1 .992h-8c-.552 0-1-.444-1-.992z"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.567 8.31V4.664c0-.81.316-1.588.879-2.16a2.97 2.97 0 0 1 2.12-.896c.797 0 1.56.322 2.122.895.563.573.879 1.35.879 2.16"}})])
          )
        }
      }
    